// extracted by mini-css-extract-plugin
module.exports = {"content":"message-module--content--TStDg","title":"message-module--title--SLr83","subtitle":"message-module--subtitle--2CfqJ"};